











import Vue from 'vue';
import AccordionEventListener from '@/components/common/accordion/AccordionEventListener.vue';
import ErrorHandlerHelper from '@/helpers/ErrorHandlerHelper';

interface IAccordionItemInstance extends Vue {
  activeUid?: number;
  isOpen?: boolean;
  uid?: number;
}

export default Vue.extend({
  name: `Accordion`,
  components: { AccordionEventListener },
  props: {
    openMultiple: {
      default: true,
      type: Boolean,
    },
  },
  methods: {
    handleStateChange(uid: number): void {
      if(!this.$slots.default) {
        return;
      }

      for(const node of this.$slots.default) {
        const nodeInstance = node.componentInstance as IAccordionItemInstance;

        if(nodeInstance.activeUid !== undefined) {
          if(typeof nodeInstance.activeUid !== `number` && nodeInstance.activeUid !== null) {
            ErrorHandlerHelper.handleError(`activeUid is not of type number or null!`, { logToConsole: true });
            return;
          }
        } else {
          ErrorHandlerHelper.handleError(`activeUid is not defined!`, { logToConsole: true });
          return;
        }

        if(nodeInstance.uid) {
          if(typeof nodeInstance.uid !== `number`) {
            ErrorHandlerHelper.handleError(`uid is not of type number!`, { logToConsole: true });
            return;
          }
        } else {
          ErrorHandlerHelper.handleError(`uid is not defined!`, { logToConsole: true });
          return;
        }

        if(nodeInstance.isOpen !== undefined) {
          if(typeof nodeInstance.isOpen !== `boolean`) {
            ErrorHandlerHelper.handleError(`isOpen is not of type boolean!`, { logToConsole: true });
            return;
          }
        } else {
          ErrorHandlerHelper.handleError(`isOpen is not defined!`, { logToConsole: true });
          return;
        }

        if(this.openMultiple) {
          nodeInstance.activeUid = nodeInstance.uid;
        } else {
          nodeInstance.activeUid = uid;
          if(nodeInstance.isOpen && nodeInstance.uid !== uid) {
            nodeInstance.isOpen = !nodeInstance.isOpen;
          }
        }

        node.componentInstance = nodeInstance;
      }
    },
  },
});
